<div class="modal fade" [id]="idModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-secondary text-white">
        <h5 class="modal-title text-white">
          <i class='bx bx-ruler me-2'></i>Novo Desenho
          <small class="d-block fw-normal opacity-75" *ngIf="subtitulo">{{ subtitulo }}</small>
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="fecharModal()" aria-label="Fechar"></button>
      </div>

      <div class="modal-body p-4">
        <div class="row g-3">
          <!--
               O arquivo vem primeiro: o nome do PDF quase sempre É o número do
               desenho, então anexar já preenche o campo abaixo e o usuário só
               confere.
          -->
          <div class="col-12">
            <label class="form-label fw-bold text-secondary">
              <i class='bx bx-file me-1'></i>Arquivo PDF
              <span class="text-danger" *ngIf="exigirArquivo">*</span>
            </label>
            <input type="file"
                   class="form-control"
                   [id]="idModal + '-arquivo'"
                   accept="application/pdf,.pdf"
                   (change)="onArquivoSelecionado($event)">
            <div class="form-text text-muted">
              Somente PDF, até 10MB. O nome do arquivo preenche o número do desenho.
            </div>
          </div>

          <div class="col-md-7">
            <label class="form-label fw-bold text-secondary">
              <i class='bx bx-hash me-1'></i>Número do desenho <span class="text-danger">*</span>
            </label>
            <input type="text"
                   class="form-control"
                   maxlength="200"
                   [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="desenho.numeroDesenho"
                   (ngModelChange)="numeroAlterado()"
                   (blur)="consultarNumero()"
                   placeholder="Ex.: DES-10452">
          </div>

          <div class="col-md-5">
            <label class="form-label fw-bold text-secondary">
              <i class='bx bx-git-branch me-1'></i>Versão <span class="text-danger">*</span>
            </label>
            <!-- Sempre calculada (1 para número novo; a maior + 1 se já existe): nunca digitada. -->
            <input type="text"
                   class="form-control"
                   readonly
                   [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="desenho.versao"
                   [placeholder]="consultando ? 'Conferindo o número...' : 'Calculada pelo número'">
          </div>

          <div class="col-12">
            <label class="form-label fw-bold text-secondary">
              <i class='bx bx-note me-1'></i>Observação
            </label>
            <textarea class="form-control"
                      rows="2"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="desenho.observacao"></textarea>
          </div>

          <div class="col-12">
            <div class="form-check">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="idModal + '-padrao'"
                     [ngModelOptions]="{standalone: true}"
                     [(ngModel)]="desenho.padrao">
              <label class="form-check-label" [for]="idModal + '-padrao'">
                Desenho padrão do produto
              </label>
              <div class="form-text text-muted">
                Marcar como padrão desmarca o desenho que era padrão antes.
              </div>
            </div>
          </div>

        </div>

        <div class="alert alert-success d-flex align-items-center mt-3 mb-0" *ngIf="arquivo">
          <i class='bx bx-check-circle me-2'></i>
          <div>
            <strong>{{ arquivo.name }}</strong>
            <small class="d-block">{{ (arquivo.size / 1024 / 1024).toFixed(2) }} MB</small>
          </div>
        </div>

        <div class="alert alert-warning d-flex align-items-center mt-3 mb-0" *ngIf="aviso && !erro">
          <i class='bx bx-info-circle me-2'></i>{{ aviso }}
        </div>

        <div class="alert alert-danger d-flex align-items-center mt-3 mb-0" *ngIf="erro">
          <i class='bx bx-error-circle me-2'></i>{{ erro }}
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="fecharModal()">
          <i class='bx bx-x me-1'></i>Cancelar
        </button>
        <button type="button" class="btn btn-success" [disabled]="consultando" (click)="confirmar()">
          <i class='bx bx-check-circle me-1'></i>Adicionar
        </button>
      </div>
    </div>
  </div>
</div>
